import React from 'react';
import logoCrevettic2 from '../../images/logo1.1.png';
import logoBludocc2 from '../../images/bludocc-logo2.png';
import { useFormik } from 'formik';
import { useHistory, useParams, Link } from 'react-router-dom';
import api from '../../services/api';
import {
  TextField,
  FormGroup,
  Container,
  Paper,
  Grid,
  InputAdornment,
  IconButton,
  Typography,
} from '@mui/material';
import SaveButton from '../../components/Buttons/SaveButton';
import * as Yup from 'yup';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useStyles } from '../../components/Styles';
import { TooltipMain } from '../../components/tooltips/tooltipsMain';
// import { styles } from "@mui/x-date-pickers/views/Calendar/Calendar";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import estilo from './styles.module.css';
import { useSelector } from 'react-redux';
import PlatformLogo from 'components/PlatformLogo';

function NewPass() {
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const [openError, setOpenError] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [showPassword1, setShowPassword1] = React.useState(false);
  const notIsFirstAccess = useSelector(
    (state) => state.notIsFirstAccess.notIsFirstAccess,
  );

  const { token } = useParams();

  async function request(data) {
    try {
      if (token) {
        data.token = token;
        await api.post('/users/resetpass', data);
      } else {
        alert('Conta não registrada');
      }
      setOpen(true);
      setTimeout(() => {
        history.push(!notIsFirstAccess ? '/first-property' : '/property');
      }, 650);
    } catch (err) {
      setOpenError(true);
    }
  }

  const formik = useFormik({
    initialValues: {
      password: '',
      password_confirmation: '',
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .matches(
          /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]))/,
          'A senha deve conter ao menos uma letra minúscula, uma letra maiúscula e um número',
        )
        .min(8, 'A senha deve conter ao menos 8 caracteres')
        .required('Campo Obrigatório'),
      password_confirmation: Yup.string()
        .oneOf([Yup.ref('password'), null], 'As senhas devem ser iguais!')
        .required('Campo Obrigatório'),
    }),
    onSubmit: (values) => {
      request(values);
    },
  });

  function handleClose(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setOpenError(false);
  }

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClickShowPassword1 = () => {
    setShowPassword1(!showPassword1);
  };

  const handleMouseDownPassword1 = (event) => {
    event.preventDefault();
  };

  return (
    <Container className={estilo.ContainerPrimary}>
      <form className={classes.root} onSubmit={formik.handleSubmit}>
        <Paper className={estilo.paper}>
          <Typography
            style={{ marginBottom: 0 }}
            variant="h6"
            align="center"
            gutterBottom
          >
            <PlatformLogo isLogin />
          </Typography>
          <section>
            <h2 className={estilo.titleLogin}>CRIAR NOVA SENHA</h2>
          </section>
          <Typography
            variant="subtitle2"
            style={{ color: '#000000', marginBlock: '1rem' }}
          >
            Agora é o momento de criar uma nova senha para acessar a plataforma.
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormGroup>
                <TextField
                  InputLabelProps={{
                    style: { pointerEvents: 'auto' },
                    shrink: true,
                  }}
                  id="formGridResp"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  name="password"
                  placeholder="Nova senha"
                  type={showPassword ? 'text' : 'password'}
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.password && formik.errors.password}
                  helperText={
                    formik.touched.password
                    && formik.errors.password
                    && formik.errors.password
                  }
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12}>
              <FormGroup>
                <TextField
                  id="formGridResp"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword1}
                          onMouseDown={handleMouseDownPassword1}
                          edge="end"
                        >
                          {showPassword1 ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  name="password_confirmation"
                  placeholder="Confirmar nova senha"
                  type={showPassword1 ? 'text' : 'password'}
                  value={formik.values.password_confirmation}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.password_confirmation
                    && formik.errors.password_confirmation
                  }
                  helperText={
                    formik.touched.password_confirmation
                    && formik.errors.password_confirmation
                    && formik.errors.password_confirmation
                  }
                />
              </FormGroup>
            </Grid>
          </Grid>

          <FormGroup>
            <div style={{ marginBlock: '1rem' }}>
              <SaveButton style={{ backgroundColor: '#F55420' }} />
            </div>

            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              open={open}
              autoHideDuration={6000}
            >
              <Alert severity="success">Senha alterada com sucesso .</Alert>
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              open={openError}
              onClose={handleClose}
              autoHideDuration={3000}
            >
              <Alert severity="error">
                Email não encontrado no sistema! Tente novamente.
              </Alert>
            </Snackbar>
          </FormGroup>
        </Paper>
      </form>
    </Container>
  );
}

export default NewPass;
